import axios from "axios";
import configuration from "@/utils/configuration";

export const financeService = {
  fetchFinancialByStatus(params) {
    return axios.get(`${configuration.backUrl}/finance/by-status`, {
      withCredentials: true,
      params,
    });
  },

  fetchFinancialSearch(params) {
    return axios.get(`${configuration.orderUrl}/finance`, {
      withCredentials: true,
      params,
    });
  },

  fetchFinancialDetail(orderNumber) {
    return axios.get(`${configuration.backUrl}/finance/detail`, {
      withCredentials: true,
      params: { order_number: orderNumber },
    });
  },

  cancelOrder(orderId) {
    return axios.patch(`${configuration.orderUrl}/cancel`, null, {
      withCredentials: true,
      params: { order_id: orderId },
    });
  },
  confirmPayment(payload) {
    return axios.patch(`${configuration.backUrl}/finance/update-order`, payload, {
      withCredentials: true,
    });
  },
  confirmSendNoti(params) {
    return axios.post(`${configuration.backUrl}/finance/notification-pay-course`, null, {
      withCredentials: true,
      params:params,
    });
  },

  financialExport(params) {
    return axios.post(`${configuration.backUrl}/finance/export`,params , {
      withCredentials: true,
      responseType: "blob",
      params: { lang:'TH' },
    });
  },
  getFinancialBill(orderId) {
    return axios.get(`${configuration.backUrl}/finance/bill`, {
      withCredentials: true,
      responseType: "blob",
      params: { order_number: orderId },
    });
  },
};
